import React from "react";

export const GoogleCalendarLink = () => {
    const baseUrl = "https://www.google.com/calendar/render?action=TEMPLATE";
  
    const buildLink = () => {
        const params = new URLSearchParams({
        text: "❤️ Fernanda & Leonardo ❤️",
        details: `Com toda humildade e alegria, damos a feliz notícia do nosso casamento                
É um prazer para nós se você também estiver presente em nossa recepção e/ou se dispuser a dar sua benção no link acima.`,
        location: "Ponteio Churrascaria - Av. Visc. de Jequitinhonha, 138 - Boa Viagem, Recife - PE, 51030-020",
        dates: "20241019T220000Z/20241020T020000Z"
        });

        return `${baseUrl}&${params.toString()}`;
    };

    return (
        <a className="bg-emerald-950 text-2xl text-gray-100 p-5 rounded-lg amatic-sc-bold" href={buildLink()} target="_blank" rel="noopener noreferrer">
            Adicionar ao Google Calendar
        </a>
    );
}


